/*
Custom code for A1PG - Price Toggle to display price including or excluding VAT
Uses Alpine.js Persist plugin to store the toggle state
*/

// Function to update all price displays on the page
function updatePriceDisplays(includeVat) {
  // If no state provided, get it from the toggle
  if (includeVat === undefined) {
    const toggle = document.querySelector('[ref="price-toggle"]');
    includeVat = toggle ? toggle.checked : true;
  }
  
  document.querySelectorAll('[ref="priceContainer"]').forEach(container => {
    container.querySelectorAll('[ref="price-incl-vat"]').forEach(price => {
      price.style.display = includeVat ? '' : 'none';
    });
    container.querySelectorAll('[ref="price-excl-vat"]').forEach(price => {
      price.style.display = includeVat ? 'none' : '';
    });
  });
}

// Watch for dynamically added price containers
new MutationObserver(() => {
  setTimeout(updatePriceDisplays, 100);
}).observe(document.body, {
  childList: true,
  subtree: true
});

// Initialize after Alpine is ready
document.addEventListener('alpine:initialized', updatePriceDisplays);

// Listen for toggle changes
document.addEventListener('price-toggle-changed', (event) => {
  updatePriceDisplays(event.detail?.includeVat);
});

// Watch for checkbox changes
document.addEventListener('DOMContentLoaded', () => {
  const toggle = document.querySelector('[ref="price-toggle"]');
  toggle?.addEventListener('change', () => updatePriceDisplays(toggle.checked));
});